import { FC } from 'react';

import DividendDocumentTableHeader from './DividendDocumentTableHeader';
import DividendDocumentTableBody from './DividendDocumentTableBody';

const DividendDocumentTable: FC = () => (
  <div className="card card-bordered card-preview mb-4">
    <table className="table table-tranx" id="dividends-distribution-table">
      <DividendDocumentTableHeader />
      <DividendDocumentTableBody />
    </table>
  </div>
);

export default DividendDocumentTable;
